import { gql } from '@apollo/client/core';

export const getProfile = gql`
  query Profile {
    profile {
      profile_url
      id
      avatar
      background
      profile_qr_code
      bio
      why
      user {
        id
        usertype
        firstname
        lastname
        title
        avatar
        background
        age
        email
        phone
        email_verified
        active
        is_creator
        status
        createdAt
        phone_verified
        token
        refreshToken
        isMarketingAgreed
      }
      benevityId
      address_line_1
      address_line_2
      city
      state
      zipcode
      channels {
        id
        channel
        description
        favorite
        createdAt
        updatedAt
        createdBy
        status
      }
      bullhorns {
        id
        bullhorn
        categoryId
        description
        createdAt
        updatedAt
        favorite
        status
        createdBy
      }
      values {
        id
        value
        description
        favorite
        createdAt
        status
        updatedAt
        createdBy
      }
      interests {
        id
        interest
        description
        status
        createdAt
        updatedAt
        favorite
        createdBy
      }
      organizations {
        id
        name
        avatar
        background
        about
        purpose
        dob
        invite_code
        invite_stage
        email
        phone
        organization_type
        profit_type
        nonprofit_type
        whyjoin_other
        whyjoin
        onboarded
        active
        approved
        denied
        withdrawn
        is_creator
        stripe_onboarded
        stripeAccountId
        benevityId
        address_line_1
        address_line_2
        city
        state
        zipcode
        createdAt
        organizationTypes
        orgId
        isFeatured
      }
    }
  }
`;

export const getUserOrganizations = gql`
  query UserOrganizations {
    profile {
      id
      avatar
      background
      user {
        id
        firstname
        lastname
        email
        phone
        age
        organizations {
          id
          name
          avatar
          background
          email
          phone
          approved
          organization_type
          onboarded
          invite_stage
        }
      }
    }
  }
`;

export const userPublicProfile = gql`
  query UserPublicProfile($id: String!) {
    userPublicProfile(id: $id) {
      id
      avatar
      background
      profile_url
      profile_qr_code
      bio
      why
      user {
        id
        usertype
        firstname
        lastname
        title
        avatar
        background
        age
        email
        phone
        email_verified
        active
        is_creator
        status
        createdAt
        phone_verified
        token
        refreshToken
        isMarketingAgreed
      }
      benevityId
      address_line_1
      address_line_2
      city
      state
      zipcode
      bullhorns {
        bullhorn
        id
      }
      values {
        value
        id
      }
      channels {
        channel
        id
      }
      interests {
        interest
        id
      }
    }
  }
`;

export const userPublicProfileBySlug = gql`
  query UserPublicProfileBySlug($slug: String!) {
    userPublicProfileBySlug(slug: $slug) {
      id
      avatar
      background
      profile_url
      profile_qr_code
      bio
      why
      user {
        id
        usertype
        firstname
        lastname
        title
        avatar
        background
        age
        email
        phone
        email_verified
        active
        is_creator
        status
        createdAt
        phone_verified
        token
        refreshToken
        isMarketingAgreed
      }
      benevityId
      address_line_1
      address_line_2
      city
      state
      zipcode
      bullhorns {
        bullhorn
        id
      }
      values {
        value
        id
      }
      channels {
        channel
        id
      }
      interests {
        interest
        id
      }
    }
  }
`;

// Mailing address (tax receipts): the signed-in user's, or an organization they admin
export const myMailingAddress = gql`
  query MyMailingAddress {
    profile {
      id
      address_line_1
      address_line_2
      city
      state
      zipcode
    }
  }
`;

export const updateAddress = gql`
  mutation UpdateAddress($input: AddressInput) {
    updateAddress(input: $input) {
      id
      address_line_1
      address_line_2
      city
      state
      zipcode
    }
  }
`;

export const organizationMailingAddress = gql`
  query OrganizationMailingAddress($orgId: String) {
    organization(orgId: $orgId) {
      id
      address_line_1
      address_line_2
      city
      state
      zipcode
    }
  }
`;

export const updateOrganizationAddress = gql`
  mutation UpdateOrganizationAddress($orgId: String, $input: OrgAddressInput) {
    updateOrganizationAddress(orgId: $orgId, input: $input) {
      id
      addressLine1
      addressLine2
      city
      state
      zipCode
    }
  }
`;
